// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"apps_app1_src_app_modules_testing-stuff_testing-stuff_module_ts":"9faa8c541ded8f6d","node_modules_html2canvas_dist_html2canvas_js":"e09bd52307aff3b8","node_modules_dompurify_dist_purify_js":"00cbaa78b5a7cbaa","node_modules_canvg_lib_index_es_js":"1212801792837e8f"}[chunkId] + ".js";
};